import { spacesToDashes } from "../helpers";

const SERVICE_SLUG_ALIASES = Object.freeze({
  couples: "for-couples-services-escorts",
});

/** Service slugs without a catalog page; not listed on the profile page. */
const HIDDEN_SERVICE_SLUGS = Object.freeze(["com"]);

/**
 * @param {Array<Object>} services Profile services from API.
 * @return {Array<Object>} Services listed on the profile page.
 */
export function filterProfileServices(services) {
  return (services || []).filter(
    (service) => !HIDDEN_SERVICE_SLUGS.includes(service.slug)
  );
}

/**
 * @param {string} slug Service slug from API.
 * @return {string} Canonical catalog slug.
 */
export function resolveServiceCatalogSlug(slug = "") {
  return SERVICE_SLUG_ALIASES[slug] || slug;
}

/**
 * @param {Object} input
 * @param {string} input.cityName Profile base city title.
 * @param {string} input.gender Profile gender.
 * @param {string} input.slug Service slug from API.
 * @return {string}
 */
export function resolveServiceCatalogPath({
  cityName = "",
  gender = "",
  slug = "",
} = {}) {
  const city = spacesToDashes(cityName);
  const serviceSlug = resolveServiceCatalogSlug(slug);

  return `/${city}/${gender.toLocaleLowerCase()}/${serviceSlug}`;
}
